export const Permissions = {
    PLATFORM_BILLING_READ: 'platform:billing:read',
    PLATFORM_BILLING_WRITE: 'platform:billing:write',
    PLATFORM_SETTINGS_READ: 'platform:settings:read',
    PLATFORM_SETTINGS_WRITE: 'platform:settings:write',
    PLATFORM_USERS_READ: 'platform:users:read',
    PLATFORM_USERS_MANAGE: 'platform:users:manage',
    PLATFORM_ROLES_READ: 'platform:roles:read',
    PLATFORM_ROLES_MANAGE: 'platform:roles:manage',
    PLATFORM_PARTNERS_READ: 'platform:partners:read',
    PLATFORM_PARTNERS_MANAGE: 'platform:partners:manage',
    PLATFORM_FEDERATION_READ: 'platform:federation:read',
    PLATFORM_FEDERATION_MANAGE: 'platform:federation:manage',

    ORG_MEMBERS_READ: 'org:members:read',
    ORG_MEMBERS_INVITE: 'org:members:invite',
    ORG_MEMBERS_REMOVE: 'org:members:remove',
    ORG_SETTINGS_READ: 'org:settings:read',
    ORG_SETTINGS_MANAGE: 'org:settings:manage',
    ORG_ROLES_READ: 'org:roles:read',
    ORG_ROLES_ASSIGN: 'org:roles:assign',
    ORG_ROLES_DEFINE: 'org:roles:define',
    ORG_BILLING_READ: 'org:billing:read',
    ORG_BILLING_MANAGE: 'org:billing:manage',

    APP_CAPABILITIES_READ: 'app:capabilities:read',
    APP_CAPABILITIES_PUBLISH: 'app:capabilities:publish',
    APP_CAPABILITIES_MANAGE: 'app:capabilities:manage',
    APP_WORKFLOWS_EXECUTE: 'app:workflows:execute',
    APP_SETTINGS_READ: 'app:settings:read',
    APP_SETTINGS_MANAGE: 'app:settings:manage',
    APP_BILLING_READ: 'app:billing:read',
    APP_BILLING_MANAGE: 'app:billing:manage',
} as const;
